define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var TagModel = /** @class */ (function () {
        function TagModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.Description = ko.observable();
            this.Color = ko.observable();
            this.IconClass = ko.observable();
            this.IconText = ko.observable();
            this.ShowIcon = ko.observable(false);
            this.ShowText = ko.observable(true);
            this.TagType = ko.observable(0);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, TagModel.Mapping, self);
            }
        }
        TagModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new TagModel(options.data);
            }
        };
        return TagModel;
    }());
    return TagModel;
});
//# sourceMappingURL=TagModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/TagModel.js
// module id = 32
// module chunks = 2